import { createComponent } from '@/common/util/templateHelpers';
import { App, Layout } from '@/common/components';

import style from './index.module.scss';

export default createComponent('EmbedLayout', { style }, function EmbedLayout ({ className }, props) {
  return (
    <Layout className={className} fillScreen>
      <App.Main>
        {props.children}
      </App.Main>
    </Layout>
  );
});
